import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { MaterialModule } from "../../shared-modules/material.module";
import { SharedModule } from "../../shared-modules/shared.module";
import { SpiderwebComponent } from "./spiderweb.component";

@NgModule({
    exports: [
        SpiderwebComponent
    ],
    imports: [
        CommonModule,
        MaterialModule,
        SharedModule,
        SpiderwebComponent
    ]
})
export class SpiderwebModule { }
